module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_yq_zhyw@2x.b1adee14.png";